import { ModuleWithProviders, NgModule } from '@angular/core';
import { PlatformService } from './services/platform/platform.service.interface';
import { PlatformServiceImpl } from './services/platform/platform.service';
import { RouterService } from '@src/app/services/router/router.service.interface';
import { RouterServiceImpl } from '@src/app/services/router/router.service';
import { StorageService } from '@src/app/services/storage/storage.service';
import { EnvironmentConfig } from '@src/app/configs/environment.config';
import {
  ApolloServiceConfig,
  createApolloServiceConfig,
  loadApolloConfig,
} from 'src/app/configs/apollo.service.config';
import { provideApollo } from 'apollo-angular';

@NgModule({
  imports: [],
  exports: [],
  providers: [
    StorageService,
    { provide: RouterService, useClass: RouterServiceImpl },
    { provide: PlatformService, useClass: PlatformServiceImpl },
    provideApollo(loadApolloConfig),
  ],
})
export class CoreModule {
  // https://www.bennadel.com/blog/3565-providing-module-configuration-using-forroot-and-ahead-of-time-compiling-in-angular-7-2-0.htm
  static forRoot(): ModuleWithProviders<CoreModule> {
    return ({
      ngModule: CoreModule,
      providers: [
        {
          provide: ApolloServiceConfig,
          useFactory: createApolloServiceConfig,
          deps: [EnvironmentConfig], // EnvironmentConfig is provided ahead of time in main.ts!
        },
      ],
    });
  }
}
